import Api from "@/services/Api";

const URL = "cxc/solicitudes-correccion-corte-caja/"

export default {
  fetch(params) {
    return Api().get(URL, {
      params: params,
    });
  },

  getById(id) {
    return Api().get(URL+id);
  },

  getByIdParams(modulo, path, id, params) {
    return Api().get(`/${modulo}/${path}/${id}/`, {
      params: params,
    });
  },

  save(params) {
    if ("id" in params) {
      return Api().put(`/${modulo}/${path}/${params.id}/`, params);
    }
    return Api().post(URL, params);
  },
  postAction(id, action, params) {
    return Api().post(URL+`${id}/${action}/`, params);
  },

  getAction(modulo, path, id, action, params) {
    return Api().get(`/${modulo}/${path}/${id}/${action}/`, {
      params: params,
    });
  },
  getActionSinId(action, params) {
    return Api().get(`${URL}${action}/`, {
      params: params,
    });
  },
};
